import axios from 'axios';
import config from '../config';
import store from '../redux/store';
import { clearUserData } from '../redux/slices/userSlice';

// Создаем экземпляр axios с базовой конфигурацией
const axiosInstance = axios.create({
    baseURL: config.API_BASE_URL,
    withCredentials: true, // Для поддержки cookies/sessions
    headers: {
        'Content-Type': 'application/json',
    },
});

// Interceptor для добавления JWT токена к запросам
axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('authToken');

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        const initData = window.Telegram?.WebApp?.initData;
        if (initData && config.method === 'post') {
            if (config.data instanceof FormData) {
                config.headers['x-init-data'] = initData;
            } else {
                if (!config.data) {
                    config.data = {};
                }
                if (typeof config.data === 'object' && !config.data.initData) {
                    config.data.initData = initData;
                }
            }
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Interceptor для обработки ответов и ошибок
axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // Если получили 401 (Unauthorized), очищаем токен и редиректим на логин
        if (error.response?.status === 401) {
            localStorage.removeItem('authToken');
            store.dispatch(clearUserData());

            // Редирект на логин только если мы не в Telegram Web App
            if (!window.Telegram?.WebApp) {
                window.location.href = '/login';
            }
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;

